<div
  [pTooltip]="subCategory?.description"
  tooltipStyleClass="xtooltip"
  class="sample-title"
  [ngStyle]="{ 'outline-color': subCategory?.checklistCategory?.rgb }"
>
  <div
    class="sample-category"
    [ngStyle]="{ 'background-color': subCategory?.checklistCategory?.rgb }"
  >
    {{ subCategory?.checklistCategory?.title }}
  </div>
  <div class="sample-subcategory" [ngStyle]="{ color: subCategory?.checklistCategory?.rgb }">
    &nbsp;<i class="fa fa-info"></i>&nbsp;{{ subCategory?.title }}
  </div>
</div>
